var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaiting = function SvgWaiting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30.652,
    viewBox: "0 0 30 30.652"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4104",
    "data-name": "Rectangle 4104",
    width: 30,
    height: 30.652,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_120",
    "data-name": "Mask Group 120",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12295",
    "data-name": "Group 12295",
    transform: "translate(4 4.087)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    cx: 11,
    cy: 11.239,
    rx: 11,
    ry: 11.239,
    fill: "none",
    stroke: "#171926",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32926",
    "data-name": "Path 32926",
    d: "M-23499-22410v7.494h6.287",
    transform: "translate(23509.479 22414.285)",
    fill: "none",
    stroke: "#171926",
    strokeWidth: 2
  })))));
};
export default SvgWaiting;